import { render, staticRenderFns } from "./steps.vue?vue&type=template&id=6eece81c&scoped=true&"
import script from "./steps.vue?vue&type=script&lang=js&"
export * from "./steps.vue?vue&type=script&lang=js&"
import style0 from "./steps.vue?vue&type=style&index=0&id=6eece81c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eece81c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eece81c')) {
      api.createRecord('6eece81c', component.options)
    } else {
      api.reload('6eece81c', component.options)
    }
    module.hot.accept("./steps.vue?vue&type=template&id=6eece81c&scoped=true&", function () {
      api.rerender('6eece81c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderDetail/comp/steps.vue"
export default component.exports